/** Breadcrumb labels for non-English locales. */

export const BREADCRUMB_LOCALE_BLOCKS = {
  hi: {
    brand: "माईतारा",
    familyMembers: "परिवार सदस्य",
    addMedication: "दवा जोड़ें",
    medicationInformation: "दवा की जानकारी",
    medicationList: "दवा सूची",
    fullChatLogs: "पूर्ण चैट लॉग",
    rescheduleAppointment: "अपॉइंटमेंट पुनर्निर्धारित करें",
    appointmentList: "अपॉइंटमेंट सूची",
    bookAppointment: "अपॉइंटमेंट बुक करें",
    profileSettings: "प्रोफ़ाइल सेटिंग",
    profile: "प्रोफ़ाइल",
    rewards: "रिवार्ड्स",
    coinWallet: "कॉइन वॉलेट",
    legal: "कानूनी",
    doctor: "डॉक्टर",
    doctorDashboard: "डैशबोर्ड",
  },
  pa: {
    brand: "ਮਾਈਤਾਰਾ",
    familyMembers: "ਪਰਿਵਾਰਕ ਮੈਂਬਰ",
    addMedication: "ਦਵਾਈ ਜੋੜੋ",
    medicationInformation: "ਦਵਾਈ ਜਾਣਕਾਰੀ",
    medicationList: "ਦਵਾਈ ਸੂਚੀ",
    fullChatLogs: "ਪੂਰੇ ਚੈਟ ਲੌਗ",
    rescheduleAppointment: "ਅਪਾਇੰਟਮੈਂਟ ਮੁੜ ਤਹ ਕਰੋ",
    appointmentList: "ਅਪਾਇੰਟਮੈਂਟ ਸੂਚੀ",
    bookAppointment: "ਅਪਾਇੰਟਮੈਂਟ ਬੁੱਕ ਕਰੋ",
    profileSettings: "ਪ੍ਰੋਫਾਈਲ ਸੈਟਿੰਗ",
    profile: "ਪ੍ਰੋਫਾਈਲ",
    rewards: "ਇਨਾਮ",
    coinWallet: "ਸਿੱਕਾ ਵਾਲਿਟ",
    legal: "ਕਾਨੂੰਨੀ",
    doctor: "ਡਾਕਟਰ",
    doctorDashboard: "ਡੈਸ਼ਬੋਰਡ",
  },
  te: {
    brand: "మైతారా",
    familyMembers: "కుటుంబ సభ్యులు",
    addMedication: "మందు జోడించండి",
    medicationInformation: "మందు సమాచారం",
    medicationList: "మందుల జాబితా",
    fullChatLogs: "పూర్తి చాట్ లాగ్‌లు",
    rescheduleAppointment: "అపాయింట్‌మెంట్ మార్చండి",
    appointmentList: "అపాయింట్‌మెంట్ జాబితా",
    bookAppointment: "అపాయింట్‌మెంట్ బుక్ చేయండి",
    profileSettings: "ప్రొఫైల్ సెట్టింగ్",
    profile: "ప్రొఫైల్",
    rewards: "రివార్డ్స్",
    coinWallet: "కాయిన్ వాలెట్",
    legal: "చట్టపరమైన",
    doctor: "డాక్టర్",
    doctorDashboard: "డాష్‌బోర్డ్",
  },
  ta: {
    brand: "மைதாரா",
    familyMembers: "குடும்ப உறுப்பினர்கள்",
    addMedication: "மருந்து சேர்",
    medicationInformation: "மருந்து தகவல்",
    medicationList: "மருந்து பட்டியல்",
    fullChatLogs: "முழு அரட்டை பதிவுகள்",
    rescheduleAppointment: "நேரம் மாற்று",
    appointmentList: "நேரம் பட்டியல்",
    bookAppointment: "நேரம் பதிவு",
    profileSettings: "சுயவிவர அமைப்பு",
    profile: "சுயவிவரம்",
    rewards: "வெகுமதிகள்",
    coinWallet: "நாணய பணப்பை",
    legal: "சட்டம்",
    doctor: "மருத்துவர்",
    doctorDashboard: "டாஷ்போர்டு",
  },
  mr: {
    brand: "मायतारा",
    familyMembers: "कुटुंब सदस्य",
    addMedication: "औषध जोडा",
    medicationInformation: "औषध माहिती",
    medicationList: "औषध यादी",
    fullChatLogs: "पूर्ण चॅट लॉग",
    rescheduleAppointment: "अपॉइंटमेंट पुनर्नियोजित करा",
    appointmentList: "अपॉइंटमेंट यादी",
    bookAppointment: "अपॉइंटमेंट बुक करा",
    profileSettings: "प्रोफाइल सेटिंग",
    profile: "प्रोफाइल",
    rewards: "बक्षीस",
    coinWallet: "कॉइन वॉलेट",
    legal: "कायदेशीर",
    doctor: "डॉक्टर",
    doctorDashboard: "डॅशबोर्ड",
  },
  bn: {
    brand: "মাইতারা",
    familyMembers: "পরিবারের সদস্য",
    addMedication: "ওষুধ যোগ করুন",
    medicationInformation: "ওষুধের তথ্য",
    medicationList: "ওষুধের তালিকা",
    fullChatLogs: "সম্পূর্ণ চ্যাট লগ",
    rescheduleAppointment: "অ্যাপয়েন্টমেন্ট পুনঃনির্ধারণ",
    appointmentList: "অ্যাপয়েন্টমেন্ট তালিকা",
    bookAppointment: "অ্যাপয়েন্টমেন্ট বুক করুন",
    profileSettings: "প্রোফাইল সেটিং",
    profile: "প্রোফাইল",
    rewards: "পুরস্কার",
    coinWallet: "কয়েন ওয়ালেট",
    legal: "আইনি",
    doctor: "ডাক্তার",
    doctorDashboard: "ড্যাশবোর্ড",
  },
  kn: {
    brand: "ಮೈತಾರಾ",
    familyMembers: "ಕುಟುಂಬ ಸದಸ್ಯರು",
    addMedication: "ಔಷಧಿ ಸೇರಿಸಿ",
    medicationInformation: "ಔಷಧಿ ಮಾಹಿತಿ",
    medicationList: "ಔಷಧಿ ಪಟ್ಟಿ",
    fullChatLogs: "ಪೂರ್ಣ ಚಾಟ್ ಲಾಗ್‌ಗಳು",
    rescheduleAppointment: "ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್ ಮರುನಿಗದಿ",
    appointmentList: "ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್ ಪಟ್ಟಿ",
    bookAppointment: "ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್ ಬುಕ್ ಮಾಡಿ",
    profileSettings: "ಪ್ರೊಫೈಲ್ ಸೆಟ್ಟಿಂಗ್",
    profile: "ಪ್ರೊಫೈಲ್",
    rewards: "ಬಹುಮಾನಗಳು",
    coinWallet: "ನಾಣ್ಯ ವಾಲೆಟ್",
    legal: "ಕಾನೂನು",
    doctor: "ವೈದ್ಯರು",
    doctorDashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
  },
};

export const applyBreadcrumbLocaleBlocks = (translations) => {
  Object.entries(BREADCRUMB_LOCALE_BLOCKS).forEach(([lang, values]) => {
    if (!translations[lang]) return;
    translations[lang].breadcrumb = {
      ...translations[lang].breadcrumb,
      ...values,
    };
  });
};
